import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "../../../shared/components/CustomInput";
import { updateAgent } from "../model/profileSlice";
import s from "../styles.module.css";
import { profileFields } from "../../../data/Fields";
import { useForm } from "react-hook-form";

const Profile = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const agentId = useSelector((state) => state.auth.agent_id);

  const [selectedImage, setSelectedImage] = useState(null);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });

  useEffect(() => {
    const fetchAgentById = async () => {
      if (agentId && token) {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_URL}/api/v1/agents/${agentId}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
          if (!response.ok) throw new Error("Ошибка загрузки данных");
          const data = await response.json();
          reset(data.agent);
          setSelectedImage(
            `${process.env.REACT_APP_API_URL}/api/v1/property/${data.agent.photo}`
          );
        } catch (error) {
          console.error("Ошибка при загрузке профиля:", error);
        }
      }
    };

    fetchAgentById();
  }, [agentId, token, reset]);


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setValue("photo", file);
      setSelectedImage(URL.createObjectURL(file));
    } else {
      console.log("Файл не выбран");
    }
  };

  const onSubmit = (data) => {
    if (agentId && token) {
      dispatch(updateAgent({ id: agentId, data }));
    }
  };

  return (
    <div className="container">
      <div className={s.nameBlock}>
        <img
          src={selectedImage || "https://ap.auezov.edu.kz/images/news/aaa001.png"}
          alt="Фото агента"
          className={s.profilePhoto}
        />
        <div>
          <h1>{watch("name") || ""}</h1>
        </div>
      </div>
      <div className={s.contactBlock}>
        <h1 className={s.title}>Контактная информация</h1>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={s.contactBox}>
            {profileFields.map((field) => (
              <CustomInput
                key={field.name}
                {...register(field.name)}
                label={field.label}
                placeholder={field.placeholder}
                type={field.type}
                error={!!errors[field.name]}
                helperText={errors[field.name]?.message}
              />
            ))}
          </div>
          <div className={s.imageUploadContainer}>
            <input name="photo" type="file" onChange={handleImageChange} />
          </div>
          <div className={s.btn}>
            <button type="submit">Сохранить</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Profile;
